// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3PaAY","active":"NavigationItem_active__1PcEN"};